module.exports = __webpack_public_path__ + "static/media/f_4.e8716892.jpg";